import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
	TIMER: '[data-fragment="AutomaticLogoutPopup.timer"]',
	BTN_CLOSE: '[data-fragment="AutomaticLogoutPopup.btnClose"]',
	BTN_LOGOUT: '[data-fragment="AutomaticLogoutPopup.btnLogout"]',
};

class AutomaticLogoutPopup extends WebComponent {

	didMount() {

		this.timerElement = this.element.querySelector(fragments.TIMER);

		this.popupInterval = null;
		this.btnCloseElement = this.element.querySelector(fragments.BTN_CLOSE);
		this.btnLogoutElement = this.element.querySelector(fragments.BTN_LOGOUT);

		window.addEventListener("keydown", ev => {
			if(ev.key !== 'Tab') {
				if(ev.key === 'Escape' || (ev.key === 'Enter' && ev.target !== this.btnLogoutElement)) {
					hidePopup();
				}
			}
		});

		const hidePopup = () => {
			clearInterval(this.popupInterval);
			if(this.btnCloseElement) {
				this.btnCloseElement.click();
			}
		}


		if(this.btnCloseElement) {
			this.btnCloseElement.focus({ focusVisible: true });
			this.btnCloseElement.addEventListener('click', () => {
				clearInterval(this.popupInterval);
			});
		}

		if(this.timerElement) {
			let startTime = 10;
			// every second inner html set to format 00:00
			this.popupInterval = setInterval(() => {
        		startTime--;
				if(startTime < 0) {
					startTime = 0;
				}
				this.timerElement.innerHTML = `00:${startTime < 10 ? '0' : ''}${startTime}`;
				this.btnLogoutElement = document.querySelector(fragments.BTN_LOGOUT);
				if(this.btnLogoutElement === null) {
					clearInterval(this.popupInterval);
				}
				if(startTime === 0) {
					setTimeout(() => {
						this.btnLogoutElement = document.querySelector(fragments.BTN_LOGOUT);
						if(this.btnLogoutElement) {
							this.btnLogoutElement.click();
						}
					}, 250);
					clearInterval(this.popupInterval);
				}
			}, 1000);
		}
	}
}

export default AutomaticLogoutPopup;




// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/AutomaticLogoutPopup.js